import {
    RESET_RESPONSIBLE_GAMING,
    SET_DEPOSIT_LIMITS_CONFIG,
    SET_PLAYER_FORCED_DEPOSIT_LIMITS_INFO,
    SET_PLAYER_FORCED_LIMITS_INFO,
    SET_PLAYER_LIMITS_INFO,
    SET_PLAYER_REALITY,
    SET_PLAYER_SELF_EXCLUSION,
    SET_RESPONSIBLE_GAMING_TIMEOUTS,
    SET_RG_CONFIGURATION,
    SET_TIMEOUTS } from './actions';

export const initialState = {
    playerLimitInfo: {},
    playerForcedLimitInfo: {},
    playerForcedDepositLimitInfo: {},
    depositLimitsConfig: {},
    timeouts: {},
    rgConfiguration: {},
    playerReality: {},
    playerSelfExclusion: {},
    responsibleGamingTimeouts: []
};

export const reducer = (state = initialState, action) => {
    switch (action.type) {
        case RESET_RESPONSIBLE_GAMING: {
            return initialState;
        }

        case SET_PLAYER_LIMITS_INFO: {
            return {
                ...state,
                playerLimitInfo: action.payload
            };
        }
        case SET_PLAYER_FORCED_LIMITS_INFO: {
            return {
                ...state,
                playerForcedLimitInfo: action.payload
            };
        }
        case SET_PLAYER_FORCED_DEPOSIT_LIMITS_INFO: {
            return {
                ...state,
                playerForcedDepositLimitInfo: action.payload
            };
        }
        case SET_DEPOSIT_LIMITS_CONFIG: {
            return {
                ...state,
                depositLimitsConfig: action.payload
            };
        }
        case SET_TIMEOUTS: {
            return {
                ...state,
                timeouts: action.payload
            };
        }
        case SET_RG_CONFIGURATION: {
            return {
                ...state,
                rgConfiguration: action.payload
            };
        }
        case SET_PLAYER_REALITY: {
            return {
                ...state,
                playerReality: action.payload
            };
        }
        case SET_PLAYER_SELF_EXCLUSION: {
            return {
                ...state,
                playerSelfExclusion: action.payload
            };
        }
        case SET_RESPONSIBLE_GAMING_TIMEOUTS: {
            return {
                ...state,
                responsibleGamingTimeouts: action.payload
            };
        }
        default:
            return state;
    }
};
